
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { authStoreGetter } from '@/store/auth.store';
import User from '@/models/User';
import { NavigationMenuItemInterface } from '@/interfaces/NavigationMenuItem.interface';
import { ROUTE_DRIVER_SEARCH, ROUTE_LOGIN } from '@/router/routes';
import { applicationStoreGetter, applicationStoreMutations } from '@/store/application.store';
import Company from '@/models/Company';
import { UserRoles } from '@/enum/UserRoles';
import { adminNavigationMenuItems, navigationMenuItems } from '@/misc/navigationMenuItems';

// @ts-ignore
import { version } from '../../package';

const AuthStore = namespace('auth');
const ApplicationStore = namespace('application');

@Component({})
export default class HomeView extends Vue {

    @AuthStore.Getter(authStoreGetter.CURRENT_USER)
    public currentUser!: User;

    @ApplicationStore.Getter(applicationStoreGetter.SELECTED_COMPANY)
    public selectedCompany!: Company;

    @ApplicationStore.Mutation(applicationStoreMutations.CLEAR_COMPANY)
    public clearCompany!: () => {};

    public navigationMenuItems: NavigationMenuItemInterface[] = [];
    private adminNavMenuItems: NavigationMenuItemInterface[] = adminNavigationMenuItems;

    private get appVersion() {
        return version;
    }

    public get flavor() {
        return process.env.VUE_APP_WHERE_AM_I;
    }

    @Watch('$route', { immediate: true })
    private onRouteChange() {
        this.$nextTick(() => {
            const allNavItems = [...this.navigationMenuItems, ...this.adminNavMenuItems];
            allNavItems.forEach(item => {
                item.isActive = false;
            });
            const activeNavItem = allNavItems.find(item => item.route === this.$route.name);
            if (!activeNavItem) return;
            activeNavItem!.isActive = true;
        });
    }

    private get navigationElements() {
        const user: User = this.$getCurrentAccount();
        if (!user) return;
        const items = navigationMenuItems.filter((item) => item.roles.includes(user.role ??
            UserRoles.COMPANY_MANAGER));
        this.navigationMenuItems = items.filter((i) => !i.isCompanyBased || this.selectedCompany);
        return this.navigationMenuItems;
    }

    /**
     * Event handler for click on nav item
     */
    public onNavItemClick(item: NavigationMenuItemInterface) {
        this.$router.push({ name: item.route });
        if (!item.isCompanyBased) this.clearCompany();
    }

    public onSearchDriverClicked() {
        this.$router.push({ name: ROUTE_DRIVER_SEARCH });
        this.clearCompany();
    }

    public get isDriverSearchActive(): boolean {
        return this.$route.path.includes(ROUTE_DRIVER_SEARCH.toString());
    }

    /**
     * On logout handler
     */
    public async onLogout() {
        // Reset each store module
        await this.$router.push({ name: ROUTE_LOGIN });
        Object
            // @ts-ignore
            .keys(this.$store._modulesNamespaceMap)
            .forEach(key => {
                this.$store.commit(`${key}CLEAR_STORE`);
            });
    }

    private get titleToShow() {
        const isAdminView = this.adminNavMenuItems.find((i) => i.route === this.$route.name);
        if (isAdminView) return 'General settings';
        if (!this.selectedCompany) return this.$t('GENERAL.NO_COMPANY');
        return this.selectedCompany.name;
    }

    private get isAdmin() {
        return this.$hasRole(UserRoles.ADMIN);
    }

    public get isManaging(): boolean {
        return this.$hasAnyRole([UserRoles.ADMIN, UserRoles.MANAGER]);
    }
}
